import { Box, Card, CardBody, ChakraProvider, Container, Heading, Icon, Text, useColorModeValue, VStack } from "@chakra-ui/react";
import React from "react";
import { FaChargingStation } from "react-icons/fa";

const AboutUsPage = () => {
  const bgColor = useColorModeValue("gray.50", "gray.900");
  const cardBg = useColorModeValue("white", "gray.800");
  const textColor = useColorModeValue("gray.700", "gray.300");
  const brandColor = "#CF642A";

  return (
    <ChakraProvider>
      <Box bg={bgColor} minHeight="100vh" py={8}>
        <Container maxW="4xl">
          <VStack spacing={8} align="stretch">
            {/* Header */}
            <Box textAlign="center" py={8}>
              <Icon as={FaChargingStation} boxSize={12} color={brandColor} mb={4} />
              <Heading size="xl" color={brandColor}>
                About Us – VET Charging Station
              </Heading>
            </Box>

            {/* Main Content */}
            <Card bg={cardBg} shadow="lg">
              <CardBody p={8}>
                <VStack spacing={6} align="stretch" textAlign="justify">
                  <Text fontSize="lg" color={textColor} lineHeight="tall">
                    Welcome to VET Charging Station, your trusted partner in sustainable transportation. We are dedicated to providing convenient, reliable, and eco-friendly electric vehicle charging solutions to make your journey smoother and greener.
                  </Text>

                  <Text fontSize="lg" color={textColor} lineHeight="tall">
                    At VET Charging Station, our mission is to support the transition to clean energy by offering accessible charging infrastructure for EV drivers. With state-of-the-art charging facilities and a commitment to sustainability, we aim to empower individuals and communities to embrace electric mobility.
                  </Text>

                  <Text fontSize="lg" color={textColor} lineHeight="tall">
                    Whether you're commuting, traveling, or running errands, VET Charging Station is here to ensure you stay charged and ready to go. Our friendly team is passionate about promoting a cleaner environment and advancing innovative transportation solutions.
                  </Text>

                  <Box textAlign="center" py={6} px={6} bg={brandColor} borderRadius="lg" color="white" mt={4}>
                    <Text fontSize="xl" fontWeight="bold">
                      Join us in building a sustainable future—charge with VET and drive towards a greener tomorrow!
                    </Text>
                  </Box>
                </VStack>
              </CardBody>
            </Card>
          </VStack>
        </Container>
      </Box>
    </ChakraProvider>
  );
};

export default AboutUsPage;
